import { Fragment } from 'react';

import { useAuth } from '../core/useAuth';
import { decodeToken } from '../core/decodeToken';
import { setStorageSubject } from '../../../utils/userStorage';

/*
 * Under whose name the browser remembers things from here on down: the
 * subject uuid of the login (`sub` in the token — see
 * utils/userStorage).
 *
 * Set while rendering rather than in an effect: everything below reads
 * the store in its own first render, and by then the key has to name
 * the right user. And keyed on that user, so a different login is a
 * different set of remembered things — what read the old one is set up
 * afresh instead of keeping what it read.
 */
export function UserStorageScope({ children }) {
  const { token } = useAuth();
  const subject = decodeToken(token)?.claims?.sub ?? null;

  setStorageSubject(subject);

  return <Fragment key={subject ?? 'nobody'}>{children}</Fragment>;
}
